import { formatDistanceToNow } from 'date-fns'
import { Message } from '@/types'
import { FallbackIndicator } from './FallbackIndicator'

interface MessageBubbleProps {
  message: Message
  currentUserEmail: string
}

export function MessageBubble({ message, currentUserEmail }: MessageBubbleProps) {
  const isCurrentUser = message.email === currentUserEmail

  return (
    <div className={`flex flex-col ${isCurrentUser ? 'items-end' : 'items-start'}`}>
      {/* Show fallback indicator for user messages that triggered fallback */}
      {isCurrentUser && message.isFallback && <FallbackIndicator message={message} />}
      
      <div className={`flex ${isCurrentUser ? 'justify-end' : 'justify-start'}`}>
        {!isCurrentUser && (
          <div className="mr-2 flex max-h-[40px] w-[40px] flex-shrink-0 items-center justify-center rounded-full bg-[#101210] p-1">
            <img src="/images/sgLogo.svg" alt="Studio Graphene Logo" width={32} height={32} className="mb-[2px] ml-[6px]" />
          </div>
        )}
        <div
          className={`message-bubble max-w-xs px-3 py-2 text-xs shadow-sm ${
            isCurrentUser
              ? 'rounded-tl-[20px] rounded-tr-[2px] rounded-br-[20px] rounded-bl-[20px] bg-blue-600 text-white'
              : message.isFromSlack
                ? 'bg-chat-message-area rounded-tl-[2px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] text-white'
                : 'rounded-tl-[2px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] border border-gray-200 bg-white text-gray-900'
          }`}
        >
          <div className="mb-1 text-xs font-medium">
            <span className="text-xs opacity-75">
              {formatDistanceToNow(new Date(message.timestamp), {
                addSuffix: true,
              })}
            </span>
          </div>
          <p className="text-xs break-words whitespace-pre-wrap">{message.text}</p>
        </div>
      </div>
    </div>
  )
}
